module.exports = __webpack_public_path__ + "static/media/YF58_8.d2d0c5da.jpg";